export default class AccountPasswordController {
	/* @ngInject */
	constructor($translate, Notification) {
		this.$translate = $translate;
		this.Notification = Notification;
	}

	/**
	 * Notify the user about the password change
	 *
	 * @memberof AccountController
	 * @function confirmPasswordChange
	 */
	confirmPasswordChange() {
		this.Notification.info({
			title:   this.$translate.instant('common.info'),
			message: this.$translate.instant('user.password-updated'),
		});
	}
}
